var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',[(_vm.error)?_c('div',[_c('div',[_vm._t("error",[_c('RequestPermissionsError',{attrs:{"error-obj":_vm.error,"error":_vm.error.message}})],{"error":_vm.error})],2)]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }